import React from 'react';
import { Icon } from '../../../../Icon/Icon';
import { useFormTextStateProps } from '../../../context';
export const AdornmentIcon = props => {
    const { $isDisabled } = useFormTextStateProps({});
    return (React.createElement(Icon, Object.assign({ ariaHidden: true }, props, ($isDisabled ? { fill: 'periwinkle-500' } : {}))));
};
//# sourceMappingURL=AdornmentIcon.js.map